/** @format */

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useSelector } from 'react-redux';

import { selectVoucherEmailStatus } from '../../redux/voucher/voucher.selector';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatusRecord = ({ messageId, status, name }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Typography variant="subtitle1" gutterBottom component="div">
        {name}
      </Typography>
      <Typography variant="subtitle2" gutterBottom component="div">
        {messageId}
      </Typography>
      <Typography variant="subtitle2" gutterBottom component="div">
        {status}
      </Typography>
    </Box>
  );
};

export default function AlertDialogSlide({ open, setOpen }) {
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const voucherEmailStatus = useSelector(selectVoucherEmailStatus);

  React.useEffect(() => {
    if (voucherEmailStatus.length > 0) {
      setOpen(true);
    }
    return () => {
      setOpen(false);
    };
  }, [voucherEmailStatus]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{'Email Request Status'}</DialogTitle>
        <DialogContent sx={{ maxHeight: '50%', overflowY: 'auto' }}>
          <DialogContentText id="alert-dialog-slide-description">
            Voucher message with template id d-67c4c33223a049b99214f3268e0f2331
            have been sent to the following customers:
            <br />
          </DialogContentText>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography variant="subtitle1" gutterBottom component="div">
              Name
            </Typography>
            <Typography variant="subtitle2" gutterBottom component="div">
              Message ID
            </Typography>
            <Typography variant="subtitle2" gutterBottom component="div">
              Status
            </Typography>
          </Box>
          {voucherEmailStatus.map((element, i) => {
            return (
              <StatusRecord
                key={i}
                messageId={element.messageId}
                status={element.status}
                name={element.name}
              />
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
